
import { mapState, mapMutations } from 'vuex'
import { getBreadCrumbsBySlug, getHeadForPage } from '~/utils'

export default {
  transition: 'fade',

  nuxtI18n: {
    paths: {
      de: '/gesuche/kurzcheck/projekte',
      fr: '/gesuche/kurzcheck/projekte',
      it: '/gesuche/kurzcheck/projekte',
    },
  },

  data() {
    return {
      // TODO: Data from CMS
      page: {
        title: this.$t('wizard.kurzcheck-project'),
        text: '<p></p>',
      },
    }
  },

  head() {
    return this.page ? getHeadForPage(this.page) : {}
  },

  computed: {
    ...mapState('navigation', { navigation: 'pages' }),
    ...mapState('applicationForms/projekte/kurzcheck', ['popup']),

    path() {
      const breadCrumbs = getBreadCrumbsBySlug(
        this.navigation,
        this.$route.path,
        this.page
      )

      return breadCrumbs
    },
  },
  methods: {
    ...mapMutations('applicationForms/projekte/kurzcheck', ['resetError']),
  },
}
